import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Production } from '../components/Production';
import { Comparison } from '../components/Comparison';
import { Benefits } from '../components/Benefits';
import { Trust } from '../components/Trust';
import { FinalCTA } from '../components/FinalCTA';
import { QuoteForm } from '../components/QuoteForm';
import { ArtworkHelp } from '../components/ArtworkHelp';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-black overflow-x-hidden" data-id="element-189">
      <Header data-id="element-190" />
      <main data-id="element-191">
        <Hero data-id="element-192" />
        <SocialProof data-id="element-193" />
        <Production data-id="element-194" />
        <ArtworkHelp data-id="element-195" />
        <QuoteForm data-id="element-196" />
        <Comparison data-id="element-197" />
        <Benefits data-id="element-198" />
        <Trust data-id="element-199" />
        <FinalCTA data-id="element-200" />
      </main>
      <Footer data-id="element-201" />
    </div>;
}